<script>
    import SFS2X, { SFSObject } from "sfs2x-api";
    import { getContext } from "svelte";
    import { get } from "svelte/store";
    import { callAtTable, getLobbyRoom, getTableRoom, unblockUser, unfriendUser } from "../controllers/SFSController";
    import { getGlobalSFS, getSFS } from '../controllers/SFSController';
    import friendsStore from '../stores/friendsStore';
    import userStore from "../stores/userStore";
    import { showToast } from '../utils/Toast';
    
    export const SET_FRIENDS_STATUS_UPDATE_INTERVAL_CMD = "pokerClient.setFriendsStatusUpdateInterval";
    export const PRIVATE_MESSAGE_CMD = "pokerClient.privateMessage";

    const context = getContext("myPlayer");
    const getMyPlayer = context ? context.getMyPlayer : null; 
    let friendsPanel;
    let isSitting = false;
    let isAtTable = false;
    let isInLobby = false;
    let mode = "friends";
    
    export function show()
    {
        friendsPanel.style.display = "block";
        setFriendsUpdateInterval(1);

        isSitting = (getMyPlayer && getMyPlayer());
        isAtTable = getTableRoom() != null;
        isInLobby = getLobbyRoom() != null;
    }

    export function hide()
    {
        friendsPanel.style.display = "none";
        setFriendsUpdateInterval(10);
    }

    function setFriendsUpdateInterval(updateIntervalSeconds)
    {
        console.log("setFriendsUpdateInterval");

        let params = new SFSObject();
        params.putInt("updateInterval", updateIntervalSeconds);
        
        if (getGlobalSFS().isConnected)
            getGlobalSFS().send(new SFS2X.ExtensionRequest(SET_FRIENDS_STATUS_UPDATE_INTERVAL_CMD, params));
        else
            showToast("ERROR: Not connected to SFS", null);
    }

    function goToLocation(locationObj)
    {
        var path = "";
        if (locationObj == "map")
            path += "/";
        else 
        {
            if (locationObj.casino)
                path += "/" + locationObj.casino;
            if (locationObj.table)
                path += "/" + locationObj.table;
            else
                path += "/lobby";
        }
        
        if (!isSitting || confirm("Are you sure you want to leave your current table to move to your friend's table?"))
            window.location = path;
    }

    function getLocationName(locationObj)
    {
        var name = "";
        if (locationObj == "map")
            name = "Map";
        else
        {
            if (locationObj.casino)
                name += "Casino " + locationObj.casino;
            if (locationObj.table)
                name += " - Table " + locationObj.table;
        }
        return name;
    }

    function getLastTimeSeen(timeSec)
    {
        if (!timeSec)
            return "";
        
        let days = Math.floor(timeSec / (3600 * 24));
        if (days > 0)
            return "Last seen: " + days + " days ago";
        else
        {
            let hours = Math.floor(timeSec / 3600);
            if (hours > 0)
                return "Last seen: " + hours + " hours ago";
            else
            {
                let mins = Math.floor(timeSec / 60);
                if (mins > 0)
                    return "Last seen: " + mins + " minutes ago";
                else
                    return "Last seen: " + timeSec + " secons ago";
            }
        }

        return "";
    }

    function onFriendChat(friendId)
    {
        if (getGlobalSFS().isConnected)
        {
            let params = new SFSObject();
            params.putUtfString("recipientId", friendId);
            params.putUtfString("message", "Hello");
            getGlobalSFS().send(new SFS2X.ExtensionRequest(PRIVATE_MESSAGE_CMD, params));
        }
        else
            showToast("ERROR: Not connected to SFS", null);
    }

    function onUnfriend(friendId)
    {
        unfriendUser(friendId);
    }

    function onUnblock(blockedId)
    {
        unblockUser(blockedId);

        friendsStore.update(friendsData => { 
            let blockedInvites = friendsData.blocked_invites;
            for(let i = 0; i<blockedInvites.length; i++)
                if(blockedInvites[i].uid == blockedId)
                {
                    blockedInvites.splice(i, 1);
                    i--;
                }

            let blockedIds = friendsData.blockedIds;
            for(let i = 0; i<blockedIds.length; i++)
                if(blockedIds[i] == blockedId)
                {
                    blockedIds.splice(i, 1);
                    i--;
                }
            
            friendsData.blocked_invites = blocked_invites;
            friendsData.blockedIds = blockedIds;
            return friendsData;
        });

        showToast("You are no longer friends", null);
    }

    function onCallFriend(friendId)
    {
        callAtTable(friendId);
    }

    function switchMode(newMode)
    {
        mode = newMode;
    }

</script>

<ion-card class="panel" bind:this={friendsPanel} style="display: none;">
    <div style="text-align: right; width: 100%; padding: 10px;"><a style="cursor: pointer;" on:click={hide}>X</a></div>
    <ion-card-header style="text-align: center;">
        {#if mode == "friends"}
        <ion-card-title>Friends</ion-card-title>
        {:else}
        <ion-card-title>Blocked Users</ion-card-title>
        {/if}
    </ion-card-header>
  
    <ion-card-content style="text-align: center; width: 100%;">
        <div class="vbox" style="width: 100%; height: 300px; overflow-y: scroll;">
        {#if mode == "friends"}
            {#each $friendsStore.friends as friend, i}
                <div class="hbox" style="align-items: center; width: 100%">
                    <svg width="30" height="30">
                        {#if friend.online}
                            <circle cx="15" cy="15" r="7" fill="green" />
                        {:else}
                            <circle cx="15" cy="15" r="7" fill="red" />
                        {/if}
                    </svg>
                    <img style="width: 50px; height: 50px;" src={friend.pic} alt={friend.uid}>
                    <span style="width: 120px; text-align: left; margin-left: 10px;">{friend.name}</span>
                    {#if friend.online}
                    <div style="width: 250px;" class="vbox">
                        <div style="width: 100%;"><a style="cursor: pointer;" on:click="{goToLocation(friend.location)}"> [{getLocationName(friend.location)}]</a></div>
                        <div style="width: 100%;" class="hbox center">
                            <a style="cursor: pointer;" on:click={onFriendChat(friend.uid)}>[Chat]</a>
                            &nbsp;&nbsp;&nbsp;
                            {#if isAtTable}
                                <a style="cursor: pointer;" on:click={onCallFriend(friend.uid)}>[Call at table]</a>
                                &nbsp;&nbsp;&nbsp;
                            {:else if isInLobby}
                                <a style="cursor: pointer;" on:click={onCallFriend(friend.uid)}>[Call in lobby]</a>
                                &nbsp;&nbsp;&nbsp;
                            {/if}
                            <a style="cursor: pointer;" on:click={onUnfriend(friend.uid)}>[Unfriend]</a>
                        </div>
                    </div>
                        
                    {:else}
                    <div style="width: 250px;" class="vbox">
                        <div style="width: 100%; text-align: center;">{getLastTimeSeen(friend.offline_time)}</div>
                        <div style="width: 100%;" class="hbox center"><a style="cursor: pointer;" on:click={onUnfriend(friend.uid)}>[Unfriend]</a></div>
                    </div>
                        
                    {/if}
                </div>
            {/each}
        {:else}
            {#each $friendsStore.blocked_invites as blocked, i}
                <div class="hbox" style="align-items: center; width: 100%">
                    <img style="width: 50px; height: 50px;" src={blocked.pic} alt={blocked.uid}>
                    <span style="width: 120px; text-align: left; margin-left: 10px;">{blocked.name}</span>
                    <div style="width: 100%;" class="hbox center"><a style="cursor: pointer;" on:click={onUnblock(blocked.uid)}>[Unblock]</a></div>
                </div>
            {/each}   
        {/if}
        </div>
        
        
        {#if mode == "friends"}
            <span><a style="cursor: pointer;" on:click={() => {switchMode("blockedUsers");}}>[See blocked users]</a></span>
        {:else}
            <span><a style="cursor: pointer;" on:click={() => {switchMode("friends");}}>[See friends]</a></span>
        {/if}

    </ion-card-content>
    
</ion-card>

<style>
    .panel {
        position: absolute;
        width: 500px;
        height: 420px;
        left: 190px;
        top: 100px;
    }

    .profilePhoto {
        width: 100px;
        height: 100px;
    }
</style>